export const endOfTitle = " | World Edu Study Abroad";
